import SectionHowItWorks from './SectionHowItWorks';
export default SectionHowItWorks;
